var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { AutocompleteInput, Button, SaveButton, SimpleForm, Toolbar, useNotify, } from "react-admin";
import { Preview, ContentCopy } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import { PREPARE_BALLOT_PUBLICATION_PREVIEW } from "@/queries/PrepareBallotPublicationPreview";
import { GET_TASK_BY_ID } from "@/queries/GetTaskById";
import { ETaskExecutionStatus } from "@sequentech/ui-core";
import { TenantContext } from "@/providers/TenantContextProvider";
import { CircularProgress } from "@mui/material";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
var ActionType;
(function (ActionType) {
    ActionType[ActionType["Copy"] = 0] = "Copy";
    ActionType[ActionType["Open"] = 1] = "Open";
})(ActionType || (ActionType = {}));
export var EditPreview = function (props) {
    var _a;
    var publicationId = props.publicationId, close = props.close, electionEventId = props.electionEventId;
    var t = useTranslation().t;
    var notify = useNotify();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _b = useWidgetStore(), addWidget = _b[0], setWidgetTaskId = _b[1], updateWidgetFail = _b[2];
    var _c = useState([]), sourceAreas = _c[0], setSourceAreas = _c[1];
    var client = useApolloClient();
    var _d = useState(null), taskId = _d[0], setTaskId = _d[1];
    var preparePreview = useMutation(PREPARE_BALLOT_PUBLICATION_PREVIEW)[0];
    var _e = React.useState(false), isUploading = _e[0], setIsUploading = _e[1];
    var tenantId = useContext(TenantContext).tenantId;
    var _f = useState(null), areaId = _f[0], setAreaId = _f[1];
    var _g = useState(null), documentId = _g[0], setDocumentId = _g[1];
    var _h = useState(null), action = _h[0], setAction = _h[1];
    var taskData = useQuery(GET_TASK_BY_ID, {
        variables: { task_id: taskId },
        skip: !taskId,
        pollInterval: taskId ? globalSettings.QUERY_POLL_INTERVAL_MS : 0,
    }).data;
    // Load identifiers, not the truncated and potentially very large EML diff.
    useEffect(function () {
        var active = true;
        setSourceAreas([]);
        var loadAreas = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, offset, data, ids, areas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        offset = 0;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, client.query({
                            query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                        query PublicationPreviewAreas(\n                            $publicationId: uuid!\n                            $eventId: uuid!\n                            $offset: Int!\n                        ) {\n                            sequent_backend_ballot_style(\n                                where: {\n                                    ballot_publication_id: {_eq: $publicationId}\n                                    election_event_id: {_eq: $eventId}\n                                }\n                                distinct_on: area_id\n                                order_by: {area_id: asc}\n                                limit: 1000\n                                offset: $offset\n                            ) {\n                                area_id\n                            }\n                        }\n                    "], ["\n                        query PublicationPreviewAreas(\n                            $publicationId: uuid!\n                            $eventId: uuid!\n                            $offset: Int!\n                        ) {\n                            sequent_backend_ballot_style(\n                                where: {\n                                    ballot_publication_id: {_eq: $publicationId}\n                                    election_event_id: {_eq: $eventId}\n                                }\n                                distinct_on: area_id\n                                order_by: {area_id: asc}\n                                limit: 1000\n                                offset: $offset\n                            ) {\n                                area_id\n                            }\n                        }\n                    "]))),
                            variables: { publicationId: publicationId, eventId: electionEventId, offset: offset },
                            fetchPolicy: "network-only",
                        })];
                    case 2:
                        data = (_a.sent()).data;
                        if (!active)
                            return [2 /*return*/];
                        ids = data.sequent_backend_ballot_style.map(function (style) { return style.area_id; });
                        if (!ids.length) return [3 /*break*/, 4];
                        return [4 /*yield*/, client.query({
                                query: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                            query PublicationPreviewAreaNames($ids: [uuid!]!, $eventId: uuid!) {\n                                sequent_backend_area(\n                                    where: {id: {_in: $ids}, election_event_id: {_eq: $eventId}}\n                                ) {\n                                    id\n                                    name\n                                }\n                            }\n                        "], ["\n                            query PublicationPreviewAreaNames($ids: [uuid!]!, $eventId: uuid!) {\n                                sequent_backend_area(\n                                    where: {id: {_in: $ids}, election_event_id: {_eq: $eventId}}\n                                ) {\n                                    id\n                                    name\n                                }\n                            }\n                        "]))),
                                variables: { ids: ids, eventId: electionEventId },
                                fetchPolicy: "network-only",
                            })];
                    case 3:
                        areas = (_a.sent()).data;
                        result.push.apply(result, areas.sequent_backend_area);
                        _a.label = 4;
                    case 4:
                        if (ids.length < 1000)
                            return [3 /*break*/, 6];
                        _a.label = 5;
                    case 5:
                        offset += 1000;
                        return [3 /*break*/, 1];
                    case 6:
                        if (active)
                            setSourceAreas(result);
                        return [2 /*return*/];
                }
            });
        }); };
        if (publicationId && electionEventId) {
            loadAreas().catch(function () {
                if (active)
                    notify(t("publish.dialog.error_preview"), { type: "error" });
            });
        }
        return function () {
            active = false;
        };
    }, [client, publicationId, electionEventId, notify, t]);
    var task = (_a = taskData === null || taskData === void 0 ? void 0 : taskData.sequent_backend_tasks_execution) === null || _a === void 0 ? void 0 : _a[0];
    useEffect(function () {
        if (!taskId || (task === null || task === void 0 ? void 0 : task.id) !== taskId)
            return;
        if (task.execution_status === ETaskExecutionStatus.SUCCESS) {
            setTaskId(null);
            setIsUploading(false);
        }
        else if (task.execution_status === ETaskExecutionStatus.FAILED) {
            setTaskId(null);
            setDocumentId(null);
            setAction(null);
            setIsUploading(false);
            notify(t("publish.dialog.error_preview"), { type: "error" });
        }
    }, [taskId, task, notify, t]);
    useEffect(function () {
        var active = true;
        if (!isUploading || taskId || documentId)
            return;
        var widget = addWidget(ETasksExecution.PREPARE_PUBLICATION_PREVIEW, undefined);
        preparePreview({ variables: { electionEventId: electionEventId, ballotPublicationId: publicationId } })
            .then(function (_a) {
            var _b;
            var data = _a.data;
            var output = data === null || data === void 0 ? void 0 : data.prepare_ballot_publication_preview;
            if ((output === null || output === void 0 ? void 0 : output.error_msg) || !(output === null || output === void 0 ? void 0 : output.document_id) || !((_b = output.task_execution) === null || _b === void 0 ? void 0 : _b.id)) {
                throw new Error((output === null || output === void 0 ? void 0 : output.error_msg) || "Preview task was not created");
            }
            setWidgetTaskId(widget.identifier, output.task_execution.id);
            if (active) {
                setDocumentId(output.document_id);
                setTaskId(output.task_execution.id);
            }
        })
            .catch(function () {
            updateWidgetFail(widget.identifier);
            if (active) {
                setDocumentId(null);
                setAction(null);
                setIsUploading(false);
                notify(t("publish.dialog.error_preview"), { type: "error" });
            }
        });
        return function () {
            active = false;
        };
    }, [isUploading]);
    var onPreviewClick = function (res) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!documentId) {
                setIsUploading(true);
            }
            setAction(ActionType.Open);
            return [2 /*return*/];
        });
    }); };
    var onCopyPreviewLinkClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!documentId) {
                setIsUploading(true);
            }
            setAction(ActionType.Copy);
            return [2 /*return*/];
        });
    }); };
    // This useEffect handles logic for action (open or copy)
    useEffect(function () {
        var openPreview = function (previewUrl) {
            try {
                window.open(previewUrl, "_blank");
                if (close)
                    close();
                notify(t("publish.preview.success"), { type: "success" });
            }
            catch (_a) {
                notify(t("publish.dialog.error_preview"), { type: "error" });
            }
        };
        var copyPreviewLink = function (previewUrl) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, navigator.clipboard.writeText(previewUrl)];
                    case 1:
                        _b.sent();
                        if (close)
                            close();
                        notify(t("publish.preview.copy_success"), { type: "success" });
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        notify(t("publish.preview.copy_error"), { type: "error" });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (documentId && !isUploading && !taskId) {
            var previewUrl = getPreviewUrl(documentId);
            if (previewUrl && action === ActionType.Copy) {
                copyPreviewLink(previewUrl);
            }
            else if (previewUrl && action === ActionType.Open) {
                openPreview(previewUrl);
            }
        }
    }, [documentId, action, isUploading, taskId]);
    // Create preview url from data
    var previewUrlTemplate = useMemo(function () {
        return "".concat(globalSettings.VOTING_PORTAL_URL, "/preview/").concat(tenantId);
    }, [globalSettings.VOTING_PORTAL_URL, tenantId]);
    var getPreviewUrl = useCallback(function (documentId) {
        if (!documentId || !areaId || !publicationId) {
            return null;
        }
        return "".concat(previewUrlTemplate, "/").concat(documentId, "/").concat(areaId, "/").concat(publicationId);
    }, [previewUrlTemplate, areaId, publicationId]);
    return (_jsxs(SimpleForm, { toolbar: false, onSubmit: onPreviewClick, children: [_jsx(AutocompleteInput, { source: "area_id", choices: sourceAreas, optionText: function (area) { return area.name; }, label: String(t("publish.preview.publicationAreas")), fullWidth: true, debounce: 100, onChange: function (res) { return setAreaId(res); } }), _jsx(Toolbar, { sx: { display: "flex", background: "white", padding: "0 !important", gap: "1rem" }, children: isUploading ? (_jsx(CircularProgress, {})) : (_jsxs(_Fragment, { children: [_jsx(SaveButton, { disabled: !areaId, icon: _jsx(Preview, {}), label: String(t("publish.preview.action")) }), _jsx(Button, { disabled: !areaId, startIcon: _jsx(ContentCopy, {}), label: String(t("publish.preview.copy")), onClick: onCopyPreviewLinkClick })] })) })] }));
};
var templateObject_1, templateObject_2;
